module.exports = __webpack_public_path__ + "assets/img/hbjh22.58997bcc.png";